
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"14"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"v","transform":"translate(-654.771 -382.398)"}},[_c('g',{attrs:{"id":"Ellipse_181","data-name":"Ellipse 181"}},[_c('circle',{attrs:{"id":"Ellipse_299","data-name":"Ellipse 299","cx":"6.4","cy":"6.4","r":"6.4","transform":"translate(655.371 382.998)","fill":"none","stroke":"#1bbc9c","stroke-width":"1.2"}})]),_c('path',{attrs:{"id":"Positive_Icon","data-name":"Positive Icon","d":"M661.329 391.729a.787.787 0 01-1.113 0l-1.21-1.209a.788.788 0 011.114-1.115l.656.653 2.648-2.65a.788.788 0 011.158 1.07l-.045.044z","fill":"#1bbc9c","stroke":"none"}})])])
          )
        }
      }
    